import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG } from "@/lib/images";
import { PageHeader } from "@/components/PageHeader";
import { Reveal, MaskLines } from "@/components/Reveal";
import { EditorialMarquee } from "@/components/Marquee";
import { SEO } from "@/components/SEO";
import { pageSEO } from "@/lib/seo";
import { useLang } from "@/i18n/LanguageContext";

export default function Studio() {
  const { c, lang } = useLang();
  const s = c.pages.studio;
  return (
    <div data-testid="studio-page">
      <SEO {...pageSEO("studio", lang)} path="/studio" lang={lang} image={IMG.marie} />
      <PageHeader eyebrow={s.eyebrow} lines={s.hLines} title="Studio" subtitle={s.subtitle} image={IMG.marie} />

      <section className="py-24 lg:py-32 bg-olime-bg">
        <div className="container-olime grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 items-center">
          <Reveal><img src={IMG.marie} alt="Marie Mazzone" className="w-full aspect-[4/5] object-cover" /></Reveal>
          <div>
            <Reveal>
              <span className="eyebrow">{s.founder}</span>
              <h2 className="font-serif text-5xl md:text-6xl tracking-tight mt-4">{c.about.name}</h2>
              <p className="mt-3 text-olime-stone tracking-[0.15em] uppercase text-xs">{s.roles}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-8 space-y-5 text-olime-muted leading-relaxed">
                {s.bio.map((p, i) => <p key={i}>{p}</p>)}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <EditorialMarquee words={["Précision", "Émotion", "Raffinement", "Sur mesure"]} />

      <section className="py-24 lg:py-32 bg-white">
        <div className="container-olime max-w-3xl text-center">
          <Reveal><span className="eyebrow">{s.credoEyebrow}</span></Reveal>
          <Reveal delay={0.1}><p className="font-serif text-2xl md:text-4xl leading-[1.4] tracking-tight mt-10 text-olime-ink">{s.credo}</p></Reveal>
          <Reveal delay={0.2}><Link to="/contact#form" data-testid="studio-contact-cta" className="btn-ink mt-14">{c.cta.contactCta} <ArrowRight size={14} /></Link></Reveal>
        </div>
      </section>
    </div>
  );
}
